function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 63.97,
  r: 47,
  fill: "#FBE5EF"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#img-prescription-3_svg__filter0_d_386_69945)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.535 37.12a1.474 1.474 0 012.208.1l2.668 3.317a1.474 1.474 0 001.736.428l3.904-1.696a1.474 1.474 0 012.002.938l1.196 4.085c.186.637.776 1.071 1.44 1.06l4.255-.073a1.474 1.474 0 011.49 1.632l-.458 4.232c-.071.66.307 1.287.925 1.53l3.96 1.562c.825.325 1.178 1.3.752 2.078l-2.043 3.735a1.474 1.474 0 00.269 1.767l3.06 2.958c.638.616.591 1.652-.1 2.208l-3.317 2.668a1.474 1.474 0 00-.428 1.736l1.696 3.904a1.474 1.474 0 01-.938 2.002l-4.085 1.195a1.474 1.474 0 00-1.06 1.44l.073 4.256a1.474 1.474 0 01-1.632 1.49l-4.232-.458a1.474 1.474 0 00-1.53.924l-1.561 3.96a1.474 1.474 0 01-2.079.753l-3.734-2.043a1.474 1.474 0 00-1.767.268l-2.958 3.061a1.474 1.474 0 01-2.209-.1L59.37 88.72a1.474 1.474 0 00-1.735-.428l-3.904 1.696a1.474 1.474 0 01-2.002-.938l-1.196-4.085a1.474 1.474 0 00-1.44-1.06l-4.256.073a1.474 1.474 0 01-1.49-1.632l.459-4.232a1.474 1.474 0 00-.925-1.53l-3.96-1.562a1.474 1.474 0 01-.752-2.078l2.043-3.734a1.474 1.474 0 00-.269-1.768l-3.06-2.958a1.474 1.474 0 01.1-2.208l3.316-2.668a1.474 1.474 0 00.428-1.735l-1.695-3.905a1.474 1.474 0 01.937-2.001l4.085-1.196a1.474 1.474 0 001.06-1.44l-.073-4.256a1.474 1.474 0 011.633-1.49l4.232.458a1.474 1.474 0 001.53-.924l1.561-3.96a1.474 1.474 0 012.079-.752l3.734 2.043a1.474 1.474 0 001.767-.27l2.958-3.06z",
  fill: "#235544"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.668 58.953l2.347.107c.334-1.518.88-2.9 1.64-4.144a11.417 11.417 0 012.875-3.154c1.146-.87 2.461-1.525 3.945-1.965 1.484-.44 3.106-.62 4.866-.54l.207.01a20.4 20.4 0 013.915.593c1.288.312 2.6.723 3.937 1.233l.182 7.028-.362-.016a24.287 24.287 0 00-.315-1.052c-.131-.42-.301-.866-.51-1.337-.21-.47-.458-.955-.747-1.452a9.396 9.396 0 00-1.024-1.43 8.967 8.967 0 00-1.342-1.288 7.218 7.218 0 00-1.684-.976l-.085-.038a8.567 8.567 0 00-1.096-.24 7.345 7.345 0 00-.963-.113c-1.046-.047-1.988.134-2.825.546-.837.411-1.568 1.018-2.192 1.82-.625.8-1.142 1.78-1.552 2.937-.409 1.146-.71 2.429-.9 3.85l9.92.45-.25.94-9.783-.445-.07.792-.037.811-.032.707c-.01.219-.01.444.003.675l9.334.424-.268.956-9.058-.412c.071 1.479.27 2.808.597 3.987.327 1.179.776 2.19 1.349 3.035.573.833 1.264 1.487 2.072 1.961.809.463 1.725.718 2.749.765.264.012.552.014.864.005.312-.02.648-.069 1.01-.145l.158-.079a7.29 7.29 0 002.517-1.355 11.393 11.393 0 001.835-1.957c.516-.702.928-1.387 1.235-2.053.318-.666.55-1.208.696-1.628l.362.016-.82 7a35.774 35.774 0 01-3.98.874 22.009 22.009 0 01-3.919.236l-.241-.01c-1.726-.08-3.313-.4-4.763-.96-1.439-.562-2.7-1.322-3.787-2.282a11.734 11.734 0 01-2.646-3.388c-.679-1.299-1.11-2.73-1.292-4.295l-1.846-.084.027-.966 1.742.079c-.015-.416-.013-.848.007-1.297.013-.287.032-.569.056-.844.025-.287.06-.568.107-.843l-2.173-.098.008-.95z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.783 49.688l6.143 6.806 7.46 8.264 7.46 8.265 4.68 5.186",
  stroke: "#235544",
  strokeWidth: 2.211,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.049 52.143l23.064 25.912",
  stroke: "#fff",
  strokeWidth: 2.948,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#img-prescription-3_svg__filter1_d_386_69945)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.535 37.12a1.474 1.474 0 012.208.1l2.668 3.317a1.474 1.474 0 001.736.428l3.904-1.696a1.474 1.474 0 012.002.938l1.196 4.085c.186.637.776 1.071 1.44 1.06l4.255-.073a1.474 1.474 0 011.49 1.632l-.458 4.232c-.071.66.307 1.287.925 1.53l3.96 1.562c.825.325 1.178 1.3.752 2.078l-2.043 3.735a1.474 1.474 0 00.269 1.767l3.06 2.958c.638.616.591 1.652-.1 2.208l-3.317 2.668a1.474 1.474 0 00-.428 1.736l1.696 3.904a1.474 1.474 0 01-.938 2.002l-4.085 1.195a1.474 1.474 0 00-1.06 1.44l.073 4.256a1.474 1.474 0 01-1.632 1.49l-4.232-.458a1.474 1.474 0 00-1.53.924l-1.561 3.96a1.474 1.474 0 01-2.079.753l-3.734-2.043a1.474 1.474 0 00-1.767.268l-2.958 3.061a1.474 1.474 0 01-2.209-.1L59.37 88.72a1.474 1.474 0 00-1.735-.428l-3.904 1.696a1.474 1.474 0 01-2.002-.938l-1.196-4.085a1.474 1.474 0 00-1.44-1.06l-4.256.073a1.474 1.474 0 01-1.49-1.632l.459-4.232a1.474 1.474 0 00-.925-1.53l-3.96-1.562a1.474 1.474 0 01-.752-2.078l2.043-3.734a1.474 1.474 0 00-.269-1.768l-3.06-2.958a1.474 1.474 0 01.1-2.208l3.316-2.668a1.474 1.474 0 00.428-1.735l-1.695-3.905a1.474 1.474 0 01.937-2.001l4.085-1.196a1.474 1.474 0 001.06-1.44l-.073-4.256a1.474 1.474 0 011.633-1.49l4.232.458a1.474 1.474 0 001.53-.924l1.561-3.96a1.474 1.474 0 012.079-.752l3.734 2.043a1.474 1.474 0 001.767-.27l2.958-3.06z",
  fill: "#1FA956"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#img-prescription-3_svg__filter2_d_386_69945)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.668 60.124l2.347.107c.334-1.518.88-2.9 1.64-4.144a11.417 11.417 0 012.875-3.155c1.146-.87 2.461-1.524 3.945-1.964 1.484-.44 3.106-.62 4.866-.54l.207.01a20.4 20.4 0 013.915.593c1.288.312 2.6.723 3.937 1.233l.182 7.028-.362-.016a24.287 24.287 0 00-.315-1.052c-.131-.42-.301-.867-.51-1.337-.21-.47-.458-.955-.747-1.452a9.396 9.396 0 00-1.024-1.43 8.967 8.967 0 00-1.342-1.288 7.218 7.218 0 00-1.684-.976l-.085-.038a8.567 8.567 0 00-1.096-.24 7.345 7.345 0 00-.963-.113c-1.046-.048-1.988.134-2.825.546-.837.411-1.568 1.018-2.192 1.82-.625.8-1.142 1.78-1.552 2.937-.409 1.145-.71 2.428-.9 3.85l9.92.45-.25.94-9.783-.445-.07.792-.037.81-.032.708c-.01.219-.01.444.003.675l9.334.424-.268.956-9.058-.412c.071 1.479.27 2.808.597 3.987.327 1.179.776 2.19 1.349 3.035.573.832 1.264 1.486 2.072 1.961.809.463 1.725.718 2.749.765.264.012.552.013.864.004.312-.02.648-.068 1.01-.144l.158-.079a7.29 7.29 0 002.517-1.355 11.393 11.393 0 001.835-1.957c.516-.703.928-1.387 1.235-2.053.318-.666.55-1.208.696-1.628l.362.016-.82 7a35.774 35.774 0 01-3.98.873 22.009 22.009 0 01-3.919.237l-.241-.01c-1.726-.08-3.313-.4-4.763-.96-1.439-.562-2.7-1.322-3.787-2.282a11.733 11.733 0 01-2.646-3.388c-.679-1.299-1.11-2.73-1.292-4.295l-1.846-.084.027-.967 1.742.08c-.015-.416-.013-.848.007-1.297.013-.287.032-.569.056-.844.025-.287.06-.568.107-.843l-2.173-.099.008-.95z",
  fill: "#fff"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M52.783 49.688l6.143 6.806 7.46 8.264 7.46 8.265 4.68 5.186",
  stroke: "#fff",
  strokeWidth: 2.211,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M52.049 52.143l23.064 25.912",
  stroke: "#1FA956",
  strokeWidth: 2.948,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M37.032 46.269l-6.204-2.153 6.204 2.153z",
  fill: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M37.032 46.269l-6.204-2.153",
  stroke: "#fff",
  strokeWidth: 2.143,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.643 41.123l-6.267-5.867 6.267 5.867z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M40.643 41.123l-6.267-5.867",
  stroke: "#fff",
  strokeWidth: 2.143,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M45.986 36.834l-2.553-5.93 2.553 5.93z",
  fill: "#000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M45.986 36.834l-2.553-5.93",
  stroke: "#fff",
  strokeWidth: 2.143,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "img-prescription-3_svg__filter0_d_386_69945",
  x: 0.183,
  y: 0.42,
  width: 128.417,
  height: 128.418,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 18.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.282353 0 0 0 0 0.623529 0 0 0 0 0.615686 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_386_69945"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_386_69945",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "img-prescription-3_svg__filter1_d_386_69945",
  x: 36.434,
  y: 36.67,
  width: 58.136,
  height: 59.37,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2.22,
  dy: 3.454
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_386_69945"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_386_69945",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "img-prescription-3_svg__filter2_d_386_69945",
  x: 43.261,
  y: 43.024,
  width: 38.418,
  height: 40.131,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.357
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_386_69945"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_386_69945",
  result: "shape"
})));

function SvgImgPrescription3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

export default __webpack_public_path__ + "static/img-prescription-3.d26e99ea.svg";
export { SvgImgPrescription3 as ReactComponent };